/**
 * Products shown in the homepage hero showcase — one per major Shingare product family, in visual-hierarchy order.
 *
 * Selection basis (no demand/sales data exists in the database — the leads collection has no product references and
 * there are no analytics events — so nothing here claims "most popular" or "best seller"):
 *   1. prominence on the source catalogue (tubecleaner.co.in): Tube Tools (cleaners, expanders, expansion systems) lead the
 *      site, followed by pipe beveling, torque/bolting and the machining families — and tube cleaner / tube expander /
 *      pipe beveling / torque / bolt-tensioner have dedicated export landing pages there;
 *   2. breadth — one product per family so the visitor sees the range, not a single machine;
 *   3. image quality — only real product photographs with usable native resolution (see scripts/build-hero-cutouts.py).
 *
 * Images are transparent cutouts of real Shingare product photos, kept at native resolution (`w`/`h`).
 * `quiet` products show their label on hover/focus only (keeps the supporting piece from cluttering the stage).
 * `href` are real routes (category or sub-category pages), never invented ones.
 *
 * Layout values are % of the showcase stage: `l` left, `t` top, `w` width. `m*` = phones (<640px). `depth` drives the
 * pointer parallax (bigger = closer), `float` the idle drift in seconds. `show` picks the breakpoint the product appears
 * at: phones show 3 (cleaner + 2), tablets 4, large desktop all 5.
 */
export const HERO_PRODUCTS = [
  {
    id: "tube-cleaner",
    eyebrow: "Tube cleaning",
    name: "Tube Cleaners",
    cta: "Explore Tube Cleaning Solutions",
    href: "/products/tube-cleaners",
    image: "/images/home/hero/tube-cleaner.webp",
    w: 603, h: 529,
    alt: "Shingare electric tube cleaner (BPC-5 series) with flexible shaft, drive unit and foot switch",
    l: 1, t: 34, width: 56, ml: 0, mt: 24, mw: 64,
    label: "left", z: 30, depth: 1, float: 7,
    show: "base",
  },
  {
    id: "pipe-beveling",
    eyebrow: "Pipe preparation",
    name: "Pipe Beveling",
    cta: "Explore Pipe Preparation Solutions",
    href: "/products/pipe-beveling-machine",
    image: "/images/home/hero/pipe-beveling.webp",
    w: 495, h: 552,
    alt: "Two Shingare portable pipe beveling machines mounted on pipe",
    l: 69, t: 0, width: 28, ml: 65, mt: 0, mw: 34,
    label: "right", z: 20, depth: 0.7, float: 8.5,
    show: "base",
  },
  {
    id: "torque-wrench",
    eyebrow: "Controlled bolting",
    name: "Torque Tools",
    cta: "Explore Bolting Solutions",
    href: "/products/bolting-tools/hydraulic-torque-wrenches",
    image: "/images/home/hero/torque-wrench.webp",
    w: 656, h: 272,
    alt: "Shingare low profile hexagon hydraulic torque wrenches",
    l: 62, t: 43, width: 36, ml: 56, mt: 60, mw: 43,
    label: "right", z: 25, depth: 0.85, float: 9,
    show: "base",
  },
  {
    id: "tube-expansion",
    eyebrow: "Tube expansion",
    name: "Tube Expansion Systems",
    cta: "Explore Tube Expansion Solutions",
    href: "/products/tube-tool/tube-expansion-systems",
    image: "/images/home/hero/tube-expansion.webp",
    w: 579, h: 273,
    alt: "Shingare pneumatic rolling drive for tube expansion",
    l: 57, t: 70, width: 40,
    label: "right", z: 22, depth: 0.6, float: 6.5,
    show: "sm",
  },
  {
    id: "tapping-machine",
    eyebrow: "Industrial machining",
    name: "Tapping Machines",
    cta: "Explore Machining Solutions",
    href: "/products/tapping-tool/electric-tapping-machine/electric-tapping-machine",
    image: "/images/home/hero/tapping-machine.webp",
    w: 262, h: 460,
    alt: "Shingare articulated arm tapping machine on a cabinet base",
    l: 43, t: 1, width: 15,
    label: "right", quiet: true, z: 10, depth: 0.45, float: 10,
    show: "xl",
  },
];
